import {type MutableRefObject} from 'react'
import {ScrollView} from 'react-native'

import {useScrollHandlers} from '#/lib/ScrollContext'
import {atoms as a} from '#/alf'
import {PrivateProfileGate} from './PrivateProfileGate'

export function PrivateGateSection({
  did,
  headerHeight,
  scrollElRef,
}: {
  did: string
  headerHeight: number
  scrollElRef: MutableRefObject<any>
}) {
  const scrollHandlers = useScrollHandlers()
  return (
    <ScrollView
      ref={scrollElRef as any}
      onScroll={scrollHandlers.onScroll}
      onScrollBeginDrag={scrollHandlers.onBeginDrag}
      onScrollEndDrag={scrollHandlers.onEndDrag}
      onMomentumScrollEnd={scrollHandlers.onMomentumEnd}
      scrollEventThrottle={16}
      contentContainerStyle={[a.px_lg, {paddingTop: headerHeight}]}>
      <PrivateProfileGate did={did} />
    </ScrollView>
  )
}
